export var copyTextToClipboard = function (text) {
    var textField = document.createElement("textarea");
    textField.innerText = text;
    document.body.appendChild(textField);
    if (window.navigator.platform === "iPhone") {
        textField.setSelectionRange(0, 99999);
    }
    else {
        textField.select();
    }
    document.execCommand("copy");
    textField.remove();
};
export var capitalize = function (str) {
    return str.charAt(0).toUpperCase() + str.substring(1);
};
export var titleCase = function (str) {
    var words = str.split(" ");
    return words.map(function (word) { return capitalize(word); }).join(" ");
};
//# sourceMappingURL=text.js.map